import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';
import EventHandler from '@pixelunion/events';

import ScrollLock from '../helpers/ScrollLock';

export default class Modal {
  constructor() {
    this.modal = document.querySelector('[data-modal]');

    if (!this.modal) { return; }

    this.overlay = this.modal.querySelector('[data-modal-overlay]');
    this.closeButton = this.modal.querySelector('[data-modal-close]');
    this.modalWindow = this.modal.querySelector('[data-modal-window]');
    this.modalContent = this.modal.querySelector('[data-modal-content]');

    if (!this.modalContent) { return; }

    this.events = new EventHandler();

    this.initialContent = this.modalContent.firstElementChild;
    this.trigger = null;
    this.classname = null;

    this.open = this.open.bind(this);
    this.updateContent = this.updateContent.bind(this);
    this.close = this.close.bind(this);

    this.events.register(this.closeButton, 'click', () => this.close());
    this.events.register(this.overlay, 'click', () => this.close());

    this._closeEsc = e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.close();
      }
    };
  }

  open(options) {
    const {
      content,
      trigger,
      classname,
      onClose,
    } = options;

    const newContent = content || this.initialContent;

    this.trigger = trigger;

    if (classname) {
      this.classname = classname;
      this.modal.classList.add(classname);
    }

    this.onClose = onClose;

    this.modal.dataset.open = 'true';
    this.modalWindow.focus();

    this.updateContent(newContent);

    ScrollLock.lock(this.modalWindow);
    this.closeEscEvent = this.events.register(window, 'keydown', e => this._closeEsc(e));
  }

  updateContent(content) {
    // Empty current content
    this.modalContent.innerHTML = '';
    // Append updated content
    this.modalContent.appendChild(content);

    trapFocus(this.modalWindow);
  }

  close() {
    removeTrapFocus(this.modalWindow);
    ScrollLock.unlock();

    if (this.closeEscEvent) {
      this.events.unregister(this.closeEscEvent);
    }

    this.modal.classList.remove(this.classname);

    if (this.trigger) {
      this.trigger.focus();
    }

    if (this.onClose) {
      this.onClose();
    }

    this.modal.dataset.open = 'false';
  }

  unload() {
    this.events.unregisterAll();
  }
}
